<template>
  <el-dialog
    top="50px"
    width="800px"
    :title="`Upload ${selectedFileType.label}`"
    :visible="visible"
    :show-close="!callingAPI"
    append-to-body
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    @close="$emit('close')"
  >
    <UploadFiles
      ref="uploadFiles"
      :selected-file-type="selectedFileType"
      :disabled="callingAPI"
    />
    <span
slot="footer"
class="dialog-footer">
      <el-button
:disabled="callingAPI"
size="medium"
@click="$emit('close')"
        >Đóng</el-button
      >
      <el-button
        type="primary"
        :loading="callingAPI"
        size="medium"
        @click="handleConfirm"
        >Lưu</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import UploadFiles from "../items/UploadFiles.vue";
import uploadServices from "@/services/upload";

export default {
  name: "UploadFilesPopup",
  components: {
    UploadFiles,
  },
  props: {
    visible: Boolean,
    selectedFileType: Object,
  },
  data() {
    return {
      callingAPI: false,
    };
  },
  methods: {
    handleConfirm() {
      const files = this.$refs.uploadFiles.fileList;
      if (files.length > 0) {
        this.callingAPI = true;
        const requests = files.map((file) =>
          uploadServices.upload(this.selectedFileType.key, file)
        );
        Promise.all(requests).finally(() => {
          this.callingAPI = false;
          this.$emit("reload");
          this.$emit("close");
        });
      } else {
        this.$message.error(
          `Bạn chưa chọn ${this.selectedFileType.label} để upload.`
        );
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
